import React from "react";
import { RxCross1 } from "react-icons/rx";
import { FaFileArchive, FaCheckCircle, FaTimes } from "react-icons/fa";

const DownloadProgressToast = ({ downloads, onRemove }) => {
  if (downloads.length === 0) return null;

  return (
    <>
      <div className="fixed bottom-4 right-4 z-50 space-y-2 w-[320px]">
        {downloads.map((download) => (
          <div
            key={download.taskId}
            className="bg-white rounded-lg shadow-2xl border border-gray-200 p-4 w-full animate-slide-up overflow-hidden"
          >
            <div className="flex items-start justify-between mb-2">
              <div className="flex items-center space-x-3 flex-1 min-w-0">
                {download.status === "completed" ? (
                  <FaCheckCircle className="text-green-500 text-xl flex-shrink-0" />
                ) : download.status === "failed" ? (
                  <FaTimes className="text-red-500 text-xl flex-shrink-0" />
                ) : (
                  <FaFileArchive className="text-blue-500 text-xl flex-shrink-0" />
                )}
                <div className="flex-1 min-w-0 overflow-hidden">
                  <p
                    className="font-medium text-sm text-gray-900 truncate"
                    title={download.fileName}
                  >
                    {download.fileName}
                  </p>
                  <p className="text-xs text-gray-500 truncate">
                    {download.status === "completed"
                      ? "Download complete"
                      : download.status === "failed"
                        ? "Download failed"
                        : download.status === "queued"
                          ? "Queued..."
                          : download.message || "Preparing download..."}
                  </p>
                </div>
              </div>
              <button
                onClick={() => onRemove(download.taskId)}
                className="ml-2 text-gray-400 hover:text-gray-600 flex-shrink-0"
              >
                <RxCross1 className="text-sm" />
              </button>
            </div>
            {download.status !== "completed" &&
              download.status !== "failed" && (
                <div className="space-y-1">
                  <div className="w-full bg-gray-200 rounded-full h-1.5">
                    <div
                      className="bg-blue-500 h-1.5 rounded-full transition-all duration-300"
                      style={{ width: `${download.progress || 0}%` }}
                    ></div>
                  </div>
                  <p className="text-xs text-gray-500 text-right">
                    {download.progress || 0}%
                  </p>
                </div>
              )}
            {download.status === "completed" && (
              <div className="mt-2 text-xs text-green-600 font-medium">
                ✓ Saved to downloads
              </div>
            )}
            {download.status === "failed" && (
              <div className="mt-2 text-xs text-red-600">
                Failed to download. Please try again.
              </div>
            )}
          </div>
        ))}
      </div>

      <style jsx>{`
        @keyframes slide-up {
          from {
            transform: translateY(100%);
            opacity: 0;
          }
          to {
            transform: translateY(0);
            opacity: 1;
          }
        }
        .animate-slide-up {
          animation: slide-up 0.3s ease-out;
        }
      `}</style>
    </>
  );
};

export default DownloadProgressToast;
